export default {
  mediaChannel: 'Media Channel',
  min: 'Min',
  max: 'Max'
}
